export const WITHOUT_PHOTO_ID = -1;
